import { isWizard, isLocalDomain } from './utils.js';

const wizDomainProxy_begin = '/WIZ_REDIRECT_TO_VP-';
const wizDomainProxy_vpExpression = '#VPID#';
const wizDomainProxy_end = '';
const wizDomainProxy_prePathTpl = wizDomainProxy_begin + wizDomainProxy_vpExpression + wizDomainProxy_end;
const wizDomainProxy_regExp = new RegExp(wizDomainProxy_prePathTpl.replace('#VPID#', '(\\d+)'));

const urlUtil = {
	/** Базовый домен для работы с сервисами, которые не входят в ЛПТК */
	remoteDomainForLPTK: 'https://cwp.li.oooinex.ru',
	mailingContext: '/mailing-manager', // для апи рассылок. Обращения проксируются в визарде с порта визарда на просто локалхост, на ПТК нжинксом на сервис, PIRS2018-779
	mediaContext: '/media-st', // для файлов, доступ напрямую к файлу на диске через веб, урл типа /media-st/000/000/000/000/123. Обращения проксируются в визарде с порта визарда на просто локалхост
	mediaContextApi: '/api/media/resources/', // для файлов, доступ файлу через яванское АПИ, урл типа /api/media/resources/123
	restrictedMediaContext: '/api/restricted-media/resources/', // для файлов, доступ файлу через яванское АПИ, урл типа /api/restricted-media/resources/001
	getDomain() {
		return window.WIZ_APIURL || ''; // если нет глоб переменной WIZ_* значит дело происходит не в предпросмотре АРМ в метавизе, а в нормально задеплоенном АРМ, то есть обращение к АПИ должно случаться к текущему домену. Вообще может сделать тупо проксирование в background.js так же как с /media?
	},
	getPath({ specMode } = {}) {
		// если security point, то /api/sp/arm/
		// если нормальный арм, то /api/arm/
		return `/api${specMode === 'sp' ? '/sp' : ''}/arm/`;
	},
	wizDomainProxy: {
		begin: wizDomainProxy_begin,
		//end: wizDomainProxy_end,
		//prePathTpl: wizDomainProxy_prePathTpl,
		//regExp: wizDomainProxy_regExp,
		//vpExpression: wizDomainProxy_vpExpression,
		getPrePathTpl(vpId) {
			// в визарде возвращает специальную подстроку которая триггерит проксирование
			// в арме - пустую строку
			return isWizard ? wizDomainProxy_prePathTpl.replace(wizDomainProxy_vpExpression, vpId) : '';
		},
		removePrePath(str) {
			return str.replace(wizDomainProxy_regExp, '');
		},
	},
	isWizard,
	isLocalDomain,
	getServiceUrl(opt) {
		const addQuery = opt.addQuery || '';
		const { specMode } = opt;

		return `${urlUtil.getDomain() + urlUtil.getPath({ specMode }) + opt.vpId}/${opt.armId}/${
			opt.methodName
		}${addQuery}`;
	},
	mixin: {
		methods: {
			// этому тут конечно не место, вынести в какой-нибудь коммон при случае
			m_indicateFileDownload() {
				this.$notify({
					title: 'Запущена генерация файла',
					text: 'Спустя некоторое время начнется скачивание. Пожалуйста, подождите',
					duration: 5000,
				});
			},
		},
	},
};

export default urlUtil;
